var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtrProfiler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_39_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05371 0.716714C9.05371 0.32085 9.37462 -6.10352e-05 9.77049 -6.10352e-05H30.2299C30.6258 -6.10352e-05 30.9467 0.320851 30.9467 0.716715V9.95019H9.05371V0.716714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5112 21.5591L17.6964 26.5342L27.2026 17.4131",
    stroke: "white",
    strokeWidth: 1.67248
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.72756,
    y: 4.80996,
    width: 32.5447,
    height: 32.9427,
    rx: 1.43355,
    stroke: "white",
    strokeWidth: 1.43355
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_39_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtrProfiler);
export default __webpack_public_path__ + "static/media/ATRProfiler.b5c69fe490445d6ce37c85e3a7f979c0.svg";
export { ForwardRef as ReactComponent };